import { __awaiter, __decorate, __extends, __generator, __metadata, __param } from "tslib";
import AccountListRepository from '../../../repository/account-list';
import { Entity } from '../../../../base/ddd-types/entity';
import { INetworkRequestService } from '../../../../base/request/network-request.interface';
var AccountListEntity = /** @class */ (function (_super) {
    __extends(AccountListEntity, _super);
    function AccountListEntity(networkRequestService, tinyId) {
        var _this = _super.call(this, tinyId) || this;
        _this.networkRequestService = networkRequestService;
        _this.accountListRepository = new AccountListRepository(networkRequestService);
        _this.accountList = [];
        return _this;
    }
    AccountListEntity.prototype.changeSign = function (u) {
        return __awaiter(this, void 0, void 0, function () {
            var resData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.accountListRepository.changeSign(u)];
                    case 1:
                        resData = (_a.sent()).resData;
                        return [2 /*return*/, (resData === null || resData === void 0 ? void 0 : resData.retcode) === 0];
                }
            });
        });
    };
    AccountListEntity.prototype.getAccountList = function (padID, folderID) {
        return __awaiter(this, void 0, void 0, function () {
            var resData;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.accountListRepository.getAccountList(padID, folderID)];
                    case 1:
                        resData = (_c.sent()).resData;
                        this.accountList = ((_b = (_a = resData === null || resData === void 0 ? void 0 : resData.data) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.accounts) ? resData.data.result.accounts : [];
                        return [2 /*return*/, this.accountList];
                }
            });
        });
    };
    AccountListEntity.prototype.delAccountForList = function (u) {
        return __awaiter(this, void 0, void 0, function () {
            var resData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.accountListRepository.delAccountForList(u)];
                    case 1:
                        resData = (_a.sent()).resData;
                        this.updateListAfterDel(u);
                        return [2 /*return*/, (resData === null || resData === void 0 ? void 0 : resData.retcode) === 0];
                }
            });
        });
    };
    AccountListEntity.prototype.updateListAfterDel = function (u) {
        this.accountList = this.accountList.filter(function (account) { return account.userIndex !== u; });
    };
    AccountListEntity = __decorate([
        __param(0, INetworkRequestService),
        __metadata("design:paramtypes", [Object, String])
    ], AccountListEntity);
    return AccountListEntity;
}(Entity));
export default AccountListEntity;
